export enum AuthMethod {
    AUTH0 = 'auth0',
    LOCAL = 'local'
}
